/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const authUserOutputDataRecruitingVolumeSchema = z.enum(['low', 'mid', 'high', 'unknown'])

export type AuthUserOutputDataRecruitingVolumeSchema = z.infer<typeof authUserOutputDataRecruitingVolumeSchema>
